// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"c365309f","339":"486665a5","514":"9793d58c","548":"2bd90765","806":"81e0297b"}[chunkId] + ".chunk.css";
};